import React, { Component } from 'react';
import { Input } from 'antd';

import Script from 'react-load-script';

class Search extends Component {
    initAutocomplete = () => {
        const { fillInAddress } = this.props;
        // Create the autocomplete object, restricting the search to geographical
        // location types.
        window.autocomplete = new window.google.maps.places.Autocomplete(
            /** @type {!HTMLInputElement} */(document.getElementById('autocomplete')),
            { types: ['geocode'] },
        );

        // When the user selects an address from the dropdown, populate the address
        // fields in the form.
        window.autocomplete.addListener('place_changed', fillInAddress);
    }

    // fillInAddress = () => {
    //     // Get the place details from the autocomplete object.
    //     const place = window.autocomplete.getPlace();

    //     console.log(JSON.stringify(place));

    //     // for (const component in componentForm) {
    //     //     document.getElementById(component).value = '';
    //     //     document.getElementById(component).disabled = false;
    //     // }

    //     // // Get each component of the address from the place details
    //     // // and fill the corresponding field on the form.
    //     // for (let i = 0; i < place.address_components.length; i++) {
    //     //     const addressType = place.address_components[i].types[0];
    //     //     if (componentForm[addressType]) {
    //     //         const val = place.address_components[i][componentForm[addressType]];
    //     //         document.getElementById(addressType).value = val;
    //     //     }
    //     // }
    // }

    geolocate = () => {
        console.log('geolocate done');
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const geolocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                const circle = new window.google.maps.Circle({
                    center: geolocation,
                    radius: position.coords.accuracy,
                });
                window.autocomplete.setBounds(circle.getBounds());
            });
        }
    }

    render() {
        return (
            <div style={{ marginTop: 40, marginBottom: 40 }}>
                <Script
                    url="https://maps.googleapis.com/maps/api/js?key=AIzaSyDBOTsJA0EQlr9PHTZc29feRXkAIn-MRtg&libraries=places"
                    onLoad={this.initAutocomplete}
                />
                <div id="locationField">
                    <Input
                        id="autocomplete"
                        placeholder="Enter the address here..."
                        onFocus={this.geolocate}
                    />
                </div>

            </div>


        );
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/component/Users/AddressAutocomplete.js